import { Description } from '../Description';
import { ModalWindowControls } from '../ModalWindowControls';
import { Header } from '../Header';
import { Modal } from '../../../Modal';

export const ModalContent = () => {
  return (
    <Modal data-testid="action-confirmation-modal">
      <Header />
      <Modal.Content>
        <Description />
      </Modal.Content>
      <Modal.Controls>
        <ModalWindowControls />
      </Modal.Controls>
    </Modal>
  );
};
